@if (customerFacade.customerBaseData$ | async; as customerBaseData) {
  @if (customerBaseData?.hasActiveWallet) {
    <div class="row">
      <div class="col">
        <h5 class="zero-text p-small-bold">{{ 'user-self-service.krypto-wallet.has-wallet.headline' | transloco | uppercase }}</h5>
        <p class="mt-2">
          {{ 'user-self-service.krypto-wallet.has-wallet.text' | transloco }}
        </p>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-4">
        {{ 'user-self-service.krypto-wallet.has-wallet.owner' | transloco }}
      </div>
      <div class="col-8">{{ customerBaseData.firstName }} {{ customerBaseData.lastName }}</div>
      <div class="col-4">{{ 'user-self-service.konto-depot.depot.bic' | transloco }}</div>
      <div class="col-8">
        <web-design-system-copy-to-clipboard label="BDWBDEMMXXX" iconCssClass="icon-dark" [hint]="'mydepot.deposit.copy-bic' | transloco" />
      </div>
      <div class="col-4">&nbsp;</div>
      <div class="col-8">{{ 'mydepot.deposit.baaderbank' | transloco }}</div>
      @if (customerFacade.customerAccountData$ | async; as accountData) {
        <div class="col-4">{{ 'user-self-service.konto-depot.depot.accountIban' | transloco }}</div>
        <div class="col-8">
          <web-design-system-copy-to-clipboard
            [label]="accountData?.accountIban | formateIban"
            iconCssClass="icon-dark"
            [hint]="'mydepot.deposit.copy-iban' | transloco"
          />
        </div>
      }
    </div>
  } @else {
    @if (customerBaseData?.kryptoEnabled && !customerBaseData?.hasActiveWallet) {
      <p>
        {{ 'user-self-service.krypto-wallet.no-wallet.text' | transloco }}
      </p>
      <web-design-system-button size="small" class="full-width-on-small-devices" [routerLink]="commonRoutes.postlogin.kryptoOnboarding">
        {{ 'user-self-service.krypto-wallet.no-wallet.btn' | transloco }}
      </web-design-system-button>
    } @else {
      <div>
        <h3>{{ 'user-self-service.krypto-wallet.coming-soon.headline' | transloco }}</h3>
        <p class="mt-2">
          {{ 'user-self-service.krypto-wallet.coming-soon.text' | transloco }}
          {{ 'user-self-service.krypto-wallet.coming-soon.link-start' | transloco }}
          <a class="link-secondary text-default cursor-pointer" [routerLink]="commonRoutes.postlogin.crypto">{{
            'user-self-service.krypto-wallet.coming-soon.link' | transloco
          }}</a>
          {{ 'user-self-service.krypto-wallet.coming-soon.link-end' | transloco }}
        </p>
      </div>
    }
  }
}
